import React, { ComponentProps, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Popover } from '@myua/kit';
import { filterConditionApplied } from '../../../../../../general/modules/filter/actions';
import { FMColumn } from '../../../model';
import { Label } from './Label';
import Picker from '@myua/date-range/dist/ant/Picker';
import 'moment/locale/ru';
import { Type } from '../../../../../../general/modules/filter/dataModel';
import { getActiveFilters } from '../../../selectors/selectors';

export const FilterDateContainer: React.FC<{
  column: FMColumn<Type.DATE>;
}> = ({ column }) => {
  const currentActiveFilter = useSelector(getActiveFilters)[column.key];
  const to = currentActiveFilter?.to;
  const from = currentActiveFilter?.from;
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const onCancel = () => {
    setOpen(false);
  };

  const onApply: ComponentProps<typeof Picker>['applyButtonOnClick'] = ({ from, to }) => {
    dispatch(filterConditionApplied({ fieldID: column.key, condition: { from, to } }));
    setOpen(false);
  };

  const onReset = () => {
    dispatch(
      filterConditionApplied({
        fieldID: column.key,
        condition: { from: undefined, to: undefined },
      }),
    );
    setOpen(false);
  };

  return (
    <div
      className="ch-file-manager__filter"
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <Popover
        trigger="click"
        placement="bottomRight"
        // Semantic звал onOpen и onClose раздельно; у antd одна ручка,
        // закрытие по-прежнему означает отмену правки фильтра.
        onOpenChange={(isOpen) => (isOpen ? setOpen(true) : onCancel())}
        open={open}
        className="gen-date-range__popup"
        content={
          <Picker
            range={{ from, to }}
            applyButtonOnClick={onApply}
            closeButtonOnClick={onCancel}
            clearButtonOnClick={onReset}
          />
        }
      >
        <Label columnKey={column.key} />
      </Popover>
    </div>
  );
};
